import { connect } from 'react-redux';

import {
    changeTypingStatus,
    endConvo,
    removeConversation,
    requestClose,
    sendMessage,
    toggleMinimized,
} from '../../actions';
import {
    getConvo,
    getLinks,
    getLocation,
    getNumUnreadMessages,
    getStarters,
    hasAnyVisitorMessages,
} from '../../selectors/conversation';
import { getSettings } from '../../selectors/settings';
import { RootState } from '../../typedefs/store';
import ConvoWrapperFactory from './ConvoWrapperFactory';

const mapStateToProps = (state: RootState) => {
    const location = getLocation(state);
    const convo = getConvo(state);
    const settings = getSettings(state);

    return {
        settings: getSettings(state),
        numUnread: getNumUnreadMessages(state),
        starters: getStarters(state),
        convoAvatar: convo.avatar,
        locationName: location.name,
        isMinimized: convo.minimized,
        showEndDialog: convo.endPending,
        ending: convo.ending,
        ended: convo.ended,
        disableSending: convo.starting,
        surveyCompleted: convo.surveyCompleted,
        links: getLinks(state),
        agent: convo.users.length > 0 && convo.users[0],
        hasAnyVisitorMessages: hasAnyVisitorMessages(state),
    };
};

const mapDispatchToProps = {
    sendMessage,
    toggleMinimized,
    requestClose,
    endConvo,
    changeTypingStatus,
    removeConversation,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvoWrapperFactory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/ConvoWrapperContainer.tsx